import * as yup from 'yup';

import { ANGOLAN_IBAN_PREFIX } from '»utils/constants';

yup.addMethod(
  yup.number,
  'noSpacesAllowed',
  function noSpacesAllowed(msgError) {
    return this.test({
      name: 'noSpacesAllowed',
      test: (_, context) => {
        const { originalValue, createError } = context;

        if (typeof originalValue === 'string' && /\s/.test(originalValue))
          return createError({ message: msgError });

        return true;
      },
    });
  },
);

yup.addMethod(
  yup.string,
  'noSpacesAllowedForTextField',
  function noSpacesAllowedForTextField(message) {
    return this.test({
      name: 'noSpacesAllowedForTextField',
      message,
      test: (value) => !/\s/.test(value ?? ''),
    });
  },
);

yup.addMethod(yup.string, 'integerOnly', function integerOnly(message) {
  return this.test({
    name: 'integerOnly',
    message,
    test: (value) => !value || /^\d+$/.test(value),
  });
});

yup.addMethod(yup.string, 'minValue', function minValue(min, message) {
  return this.test({
    name: 'minValue',
    message,
    test: (value) => {
      if (!value) return true;

      const numeric = Number(value);
      if (isNaN(numeric)) return true;

      return numeric >= min;
    },
  });
});

yup.addMethod(
  yup.string,
  'ibanAoFormatValidation',
  function ibanAoFormatValidation(msgError) {
    return this.test({
      name: 'ibanAoFormatValidation',
      message: msgError,
      test: (value) => {
        if (!value) return true;

        return /^AO\d{23}$/.test(value);
      },
    });
  },
);

yup.addMethod(
  yup.string,
  'ibanAo06FormatValidation',
  function ibanAo06FormatValidation(msgError) {
    return this.test({
      name: 'ibanAo06FormatValidation',
      message: msgError,
      test: (value) => {
        if (!value) return true;

        return new RegExp(`^${ANGOLAN_IBAN_PREFIX}\\d{21}$`).test(value);
      },
    });
  },
);

yup.addMethod(
  yup.string,
  'differentFromField',
  function differentFromField(fieldName, msgError) {
    return this.test({
      name: 'differentFromField',
      message: msgError,
      test: function (value) {
        const compareValue = this.parent?.[fieldName];

        if (!value || !compareValue) return true;

        return value.trim().toUpperCase() !== compareValue.trim().toUpperCase();
      },
    });
  },
);

export default yup;
